// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCSDS_jo6oIwOBmjVjnw47AzUgKBdswLuw",
    authDomain: "newswav-marketplace.firebaseapp.com",
    projectId: "newswav-marketplace",
    storageBucket: "newswav-marketplace.firebasestorage.app",
    messagingSenderId: "866556589647",
    appId: "1:866556589647:web:a5b8cef7f1adf8e67e9c3a",
    measurementId: "G-MN3CKQ6223"
};

const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Analytics
const analytics = getAnalytics(app);

// Export a logEvent wrapper function
export const logFirebaseEvent = (eventName, sendData) => {
    logEvent(analytics, eventName, sendData);
};
